export default function getResource(label, vars = []) {
    const resources = {
        emailAndMailPreferences: 'Courriel et préférences',
        communicationPreferences: 'Communication Preferences'
    };
    return resources[label];
}
